import React, {useEffect, useState} from "react";
import ItemBox from "./item/itemBox";
import Loader from "../commons/loader";
import {dashboardMyItemsLinks, DISABLED, GLOBAL_BORDER_RADIUS_ACCENTUATED} from "../../costants";
import MainButton from "../commons/mainButton";
import ButtonsToOrderItems from "./premium/buttonsToOrderItems";
import {Route, Routes, useNavigate} from "react-router-dom";
import {httpsCallable} from "firebase/functions";
import {functions} from "../../firebase";
import MyNormalText from "../commons/myNormalText";

function MyItems({rentUser, currentPageUrl, premiumPalette}) {
    const navigate = useNavigate();

    const primaryColor = premiumPalette.primaryColor;
    const secondaryColor = premiumPalette.secondaryColor;

    const currentlyOnVetrina = currentPageUrl.includes(dashboardMyItemsLinks.VETRINA);
    const currentlyOnArchivedSection = currentPageUrl.includes(dashboardMyItemsLinks.ARCHIVE);

    const [items, setItems] = useState([]);
    const [itemsArchived, setItemsArchived] = useState([]);
    const [refreshItems, setRefreshItems] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const pageSize = 64;

    useEffect(() => {
        getItems();
    }, [refreshItems, pageNumber]);

    function getItems() {
        setLoading(true);
        const rentItemsListView = httpsCallable(functions, "rentItemsListView");
        rentItemsListView({
            rentId: rentUser.rentId,
            archived: true,
            pageNumber: pageNumber,
            pageSize: pageSize,
        })
            .then((result) => {
                const {items, totalItems, hasMore} = result.data;
                setItems(items.filter((item) => !item.archived));
                setItemsArchived(items.filter((item) => item.archived));
                setTotalItems(totalItems);
                setHasMore(hasMore);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }

    function handleRefreshItems() {
        setPageNumber(1);
        setRefreshItems(!refreshItems);
    }

    function handlePreviousPage() {
        if (pageNumber > 1) {
            setPageNumber((prev) => prev - 1);
        }
    }

    function handleNextPage() {
        if (hasMore) {
            setPageNumber((prev) => prev + 1);
        }
    }

    function handleChangeMyItemsSection(section) {
        setPageNumber(1);
        setSelectedCategory(null); // Reset category filter when switching sections
        navigate(section);
    }

    function getCategoryOptions() {
        const categories = rentUser.categories.map(category => ({
            value: category,
            label: category
        }));
        return [{value: null, label: 'Tutte le categorie'}, ...categories];
    }

    function filterItemsByCategory(itemsToFilter) {
        if (!selectedCategory) {
            return itemsToFilter;
        }
        return itemsToFilter.filter(item => item.category === selectedCategory);
    }

    function onlineItems(itemsToShow) {
        const filteredItems = filterItemsByCategory(itemsToShow);
        const totalPages = Math.ceil(totalItems / pageSize);

        return (
            <>
                <div style={pageStyle.filterContainer}>
                    <MyNormalText text={'Filtra per categoria'} bold={true} fontSize={18}/>
                    <div style={pageStyle.categoryButtons}>
                        {getCategoryOptions().map((option) => (
                            <div>
                                <MainButton
                                    key={option.value || 'all'}
                                    text={option.label}
                                    action={() => setSelectedCategory(option.value)}
                                    borderRadius={GLOBAL_BORDER_RADIUS_ACCENTUATED}
                                    backgroundColor={selectedCategory === option.value ? secondaryColor : primaryColor}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <ButtonsToOrderItems
                    items={currentlyOnVetrina ? items : itemsArchived}
                    setItems={currentlyOnVetrina ? setItems : setItemsArchived}
                    premiumPalette={premiumPalette}
                    buttonsColor={primaryColor}
                />
                {loading ? (
                    <Loader color={secondaryColor}/>
                ) : (
                    <div style={pageStyle.itemList}>
                        {filteredItems.map((item) => (
                            <div key={item.id} style={pageStyle.itemContainer}>
                                <ItemBox
                                    rentUser={rentUser}
                                    premiumPalette={premiumPalette}
                                    refreshItems={handleRefreshItems}
                                    openOperations={true}
                                    item={item}
                                    width={"100%"}
                                    imageHeight={120}
                                />
                            </div>
                        ))}
                    </div>
                )}
                {totalItems > 0 && (
                    <div style={pageStyle.paginationContainer}>
                        <MainButton
                            action={handlePreviousPage}
                            image={require("../../imgs/actions/arrow-left.png")}
                            borderRadius={GLOBAL_BORDER_RADIUS_ACCENTUATED}
                            backgroundColor={pageNumber === 1 ? DISABLED : primaryColor}
                            disabled={pageNumber === 1}
                        />
                        <MyNormalText text={`Pagina ${pageNumber} di ${totalPages}`}/>
                        <MainButton
                            action={handleNextPage}
                            image={require("../../imgs/actions/arrow-right.png")}
                            borderRadius={GLOBAL_BORDER_RADIUS_ACCENTUATED}
                            backgroundColor={!hasMore ? DISABLED : primaryColor}
                            disabled={!hasMore}
                        />
                    </div>
                )}
            </>
        );
    }

    return (
        <div style={pageStyle.container}>
            <div style={pageStyle.buttonsContainer}>
                <div>
                    <MainButton
                        text={`In Vetrina`}
                        action={() => handleChangeMyItemsSection(dashboardMyItemsLinks.VETRINA)}
                        borderRadius={GLOBAL_BORDER_RADIUS_ACCENTUATED}
                        backgroundColor={currentlyOnVetrina ? secondaryColor : primaryColor}
                    />
                </div>
                <div>
                    <MainButton
                        text={`Archiviati`}
                        action={() => handleChangeMyItemsSection(dashboardMyItemsLinks.ARCHIVE)}
                        borderRadius={GLOBAL_BORDER_RADIUS_ACCENTUATED}
                        backgroundColor={currentlyOnArchivedSection ? secondaryColor : primaryColor}
                    />
                </div>
            </div>
            <div>
                <Routes>
                    <Route path={dashboardMyItemsLinks.VETRINA} element={onlineItems(items)}/>
                    <Route path={dashboardMyItemsLinks.ARCHIVE} element={onlineItems(itemsArchived)}/>
                </Routes>
            </div>
        </div>
    );
}

const pageStyle = {
    container: {
        display: "flex",
        flexDirection: "column",
        gap: 30,
    },
    buttonsContainer: {
        display: "flex",
        gap: 10,
    },
    filterContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 10,
        marginBottom: 20,
    },
    categoryButtons: {
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
    },
    itemList: {
        marginTop: 10,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: 10,
    },
    itemContainer: {
        marginBottom: 20,
    },
    paginationContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 15,
        marginTop: 20
    }
};

export default MyItems;
